import * as actionTypes from './actionTypes';

export const fetchRecentPlaces = () => {
  return {
    type: actionTypes.FETCH_RECENT_PLACES,
  };
};

export const fetchRecentPlacesStart = () => {
  return {
    type: actionTypes.FETCH_RECENT_PLACES_START,
  };
};

export const fetchRecentPlacesSuccess = (recentPlaces) => {
  return {
    type: actionTypes.FETCH_RECENT_PLACES_SUCCESS,
    recentPlaces,
  };
};

export const fetchRecentPlacesFailed = (error) => {
  return {
    type: actionTypes.FETCH_RECENT_PLACES_FAILED,
    error,
  };
};

export const fetchUserRecentActivity = (Show, UserId, isManagedUser, Page, PageSize) => {
  return {
    type: actionTypes.FETCH_USER_RECENT_ACTIVITY,
    Show,
    UserId,
    isManagedUser,
    Page,
    PageSize,
  };
};

export const fetchUserRecentActivityStart = (Show, Page) => {
  return {
    type: actionTypes.FETCH_USER_RECENT_ACTIVITY_START,
    Show,
    Page,
  };
};

export const fetchUserRecentActivitySuccess = (UserRecentActivity, Showing) => {
  return {
    type: actionTypes.FETCH_USER_RECENT_ACTIVITY_SUCCESS,
    UserRecentActivity,
    Showing,
  };
};

export const fetchUserRecentActivityFailed = (error) => {
  return {
    type: actionTypes.FETCH_USER_RECENT_ACTIVITY_FAILED,
    error,
  };
};
